<div class="variants-container" *ngIf="productVariants">
    <ng-container *ngFor="let variant of productVariants|keyvalue">
        <h4>{{translateHelper.localize(variant.value.name)}}</h4>

        <ng-container *ngFor="let product of variant.value.products|keyvalue">
            <ng-container *ngIf="currentProductId != product.value._id">
                <app-variant-product [product]="product.value"></app-variant-product>
            </ng-container>
        </ng-container>

    </ng-container>
</div>